import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { inviteCollaboratorService } from 'src/api/collection'
import { inviteCollaboratorSuccess } from 'src/reducers/collection/action'
import { INVITE_COLLABORATOR } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* inviteCollaboratorFlow(payload) {
  try {
    const { id, data, callback } = payload
    const response = yield call(inviteCollaboratorService, id, data)
    yield put(inviteCollaboratorSuccess(data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* inviteCollaboratorWatcher() {
  while (true) {
    const action = yield takeMaybe(INVITE_COLLABORATOR)
    const { payload } = action

    yield fork(generalSaga, inviteCollaboratorFlow, payload)
  }
}
